import script from "./UserInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./UserInfo.vue?vue&type=script&setup=true&lang=js"

import "./UserInfo.vue?vue&type=style&index=0&id=65fe2e00&lang=css"

const __exports__ = script;

export default __exports__